import { gql } from "graphql-tag";

export const GET_ANALYTICS_DISPUTE_PIPELINE = gql`
  query AnalyticsDisputePipeline($params: GetAnalyticsInput!) {
    analyticsDisputePipeline(params: $params) {
      summary {
        pending {
          count
          amount
        }
        submitted {
          count
          amount
        }
      }
      purchasers {
        purchaser {
          purchaserId
          purchaserKey
          purchaserName
        }
        isOthers
        pending {
          count
          amount
        }
        submitted {
          count
          amount
        }
        totalAmount
      }
    }
  }
`;
